export const FETCH_EMAGAZINES_REQUEST = "FETCH_EMAGAZINES_REQUEST";
export const FETCH_EMAGAZINES_SUCCESS = "FETCH_EMAGAZINES_SUCCESS";
export const FETCH_EMAGAZINES_FAILURE = "FETCH_EMAGAZINES_FAILURE";